import React, { useEffect, useRef } from 'react';
import * as signalR from '@microsoft/signalr';
import { HubConnection } from '@microsoft/signalr';

interface AgmStatusProps {
    authQueryParams: string
    onAgmStatusUpdate: any
}

export const AgmStatus: React.FC<AgmStatusProps> = ({ authQueryParams, onAgmStatusUpdate }) => {
    const connectionRef = useRef<HubConnection>();

    useEffect(() => {
        if (!connectionRef.current || connectionRef.current.state === signalR.HubConnectionState.Disconnected) {
            const connectionUrl = `hubs/agm?${authQueryParams}`;
            const newConnection = new signalR.HubConnectionBuilder()
                .withUrl(connectionUrl)
                .withAutomaticReconnect()
                .build();

            connectionRef.current = newConnection
        }
    }, [authQueryParams]);

    useEffect(() => {
        const connection = connectionRef.current;

        if (connection && connection.state === signalR.HubConnectionState.Disconnected) {
            connection.start()
                .then(() => {
                    connection.on('agmStatusUpdate', payload => {
                        onAgmStatusUpdate(payload.oldStatus, payload.newStatus)
                    })

                    connection.on('connectionRejected', message => {
                        // Cancel auto reconnect
                        connection.stop()
                    })

                    // Subscribe for AGM updates
                    connection.send('subscribe')
                })
                .catch(err => console.error(err));
        }
    }, [connectionRef, onAgmStatusUpdate]);

    // Detect when the page becomes visible again (e.g., after unlock)
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                const connection = connectionRef.current;

                // Trigger an AGM update to resync
                onAgmStatusUpdate(null, null);

                // Try to restart if it�s disconnected
                if (connection && connection.state === signalR.HubConnectionState.Disconnected) {
                    connection.start()
                        .then(() => {
                            console.log('SignalR reconnected after visibility change');
                        })
                        .catch(err => {
                            console.error('Error reconnecting SignalR after visibility change', err);
                        });
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return (
        <></>
    );
}